export default __webpack_public_path__ + "static/media/menCoatTrousers.75eee8e4.svg";